import React from 'react';
import AccountList from './AccountList';

const ClientsAccounts = () => {
  return <AccountList baseAccountId={12} />;
};

export default ClientsAccounts;
